"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceTeamMessageSchema = exports.InvoiceTaskSchema = exports.InvoiceTask = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
var InvoiceTask;
(function (InvoiceTask) {
    InvoiceTask["UPDATE_DRAFT"] = "UPDATE_DRAFT";
    InvoiceTask["FINALISE"] = "FINALISE";
})(InvoiceTask = exports.InvoiceTask || (exports.InvoiceTask = {}));
exports.InvoiceTaskSchema = (0, core_1.StringUnion)([InvoiceTask.UPDATE_DRAFT, InvoiceTask.FINALISE], {
    title: "Invoice task type",
    description: "The intended task of the invoice process",
});
exports.InvoiceTeamMessageSchema = (0, core_1.StrictObject)({
    // The start and end period for the invoice to cover
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    task: exports.InvoiceTaskSchema,
    campaigns: typebox_1.Type.Array((0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
    })),
    tier: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
    team: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
});
